export default "__VITE_ASSET__CV4kWv15__"